
import moment from "moment"
class Utils {

	/**
	 * Get first character from first & last sentences of a username
	 * @param {String} name - Username
	 * @return {String} 2 characters string
	 */
	static getNameInitial(name) {
		let initials = name.match(/\b\w/g) || [];
		return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
	}

	/**
	 * Get current path related object from Navigation Tree
	 * @param {Array} navTree - Navigation Tree from directory 'configs/NavigationConfig'
	 * @param {String} path - Location path you looking for e.g '/app/dashboards/analytic'
	 * @return {Object} object that contained the path string
	 */
	static getRouteInfo(navTree, path) {
		if( navTree.path === path ){
		  return navTree;
		}
		let route;
		for (let p in navTree) {
		  if( navTree.hasOwnProperty(p) && typeof navTree[p] === 'object' ) {
				route = this.getRouteInfo(navTree[p], path);
				if(route){
					return route;
				}
		  }
		}
		return route;
	}

	/**
	 * Get accessible color contrast
	 * @param {String} hex - Hex color code e.g '#3e82f7'
	 * @return {String} 'dark' or 'light'
	 */
	static getColorContrast(hex){
		const threshold = 130;
		const hRed = hexToR(hex);
		const hGreen = hexToG(hex);
		const hBlue = hexToB(hex);
		function hexToR(h) {return parseInt((cutHex(h)).substring(0,2),16)}
		function hexToG(h) {return parseInt((cutHex(h)).substring(2,4),16)}
		function hexToB(h) {return parseInt((cutHex(h)).substring(4,6),16)}
		function cutHex(h) {return (h.charAt(0) === '#') ? h.substring(1,7):h}
		const cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
		if (cBrightness > threshold){
			return 'dark'
		} else {
			return 'light'
		}
	}

	/**
	 * Darken or lighten a hex color
	 * @param {String} color - Hex color code e.g '#3e82f7'
	 * @param {Number} percent - Percentage -100 to 100, positive for lighten, negative for darken
	 * @return {String} Darken or lighten color
	 */
	static shadeColor(color, percent) {
		let R = parseInt(color.substring(1,3),16);
		let G = parseInt(color.substring(3,5),16);
		let B = parseInt(color.substring(5,7),16);
		R = parseInt(R * (100 + percent) / 100);
		G = parseInt(G * (100 + percent) / 100);
		B = parseInt(B * (100 + percent) / 100);
		R = (R<255)?R:255;
		G = (G<255)?G:255;
		B = (B<255)?B:255;
		const RR = ((R.toString(16).length === 1) ? `0${R.toString(16)}` : R.toString(16));
		const GG = ((G.toString(16).length === 1) ? `0${G.toString(16)}` : G.toString(16));
		const BB = ((B.toString(16).length === 1) ? `0${B.toString(16)}` : B.toString(16));
		return `#${RR}${GG}${BB}`;
	}

	/**
	 * Returns either a positive or negative
	 * @param {Number} number - number value
	 * @param {any} positive - value that return when positive
	 * @param {any} negative - value that return when negative
	 * @return {any} positive or negative value based on param
	 */
	static getSignNum(number, positive, negative) {
		if (number > 0) {
			return positive
		}
		if (number < 0) {
			return negative
		}
		return null
	}

	/**
	 * Returns either ascending or descending value
	 * @param {Object} a - antd Table sorter param a
	 * @param {Object} b - antd Table sorter param b
	 * @param {String} key - object key for compare
	 * @return {any} a value minus b value
	 */
	static antdTableSorter(a, b, key) {
		if(typeof a[key] === 'number' && typeof b[key] === 'number') {
			return a[key] - b[key]
		}

		if(typeof a[key] === 'string' && typeof b[key] === 'string') {
			a = a[key].toLowerCase();
			b = b[key].toLowerCase();
			return a > b ? -1 : b > a ? 1 : 0;
		}
		return
	}

	/**
	 * Filter array of object
	 * @param {Array} list - array of objects that need to filter
	 * @param {String} key - object key target
	 * @param {any} value  - value that excluded from filter
	 * @return {Array} a value minus b value
	 */
	static filterArray(list, key, value) {
		let data = list
		if(list) {
			data = list.filter(item => item[key] === value)
		}
		return data
	}

	/**
	 * Remove object from array by value
	 * @param {Array} list - array of objects
	 * @param {String} key - object key target
	 * @param {any} value  - target value
	 * @return {Array} Array that removed target object
	 */
	static deleteArrayRow(list, key, value) {
		let data = list
		if(list) {
			data = list.filter(item => item[key] !== value)
		}
		return data
	}

	/**
	 * Wild card search on all property of the object
	 * @param {Number | String} input - any value to search
	 * @param {Array} list - array for search
	 * @return {Array} array of object contained keyword
	 */
	static wildCardSearch(list, input) {
		const searchText = (item) => {
			for (let key in item) {
				if (item[key] == null) {
					continue;
				}
				if (item[key].toString().toUpperCase().indexOf(input.toString().toUpperCase()) !== -1) {
					return true;
				}
			}
		};
		list = list.filter(value => searchText(value));
		return list;
	}

	/**
	 * Get Breakpoint
	 * @param {Object} screens - Grid.useBreakpoint() from antd
	 * @return {Array} array of breakpoint size
	 */
	static getBreakPoint(screens) {
		let breakpoints = []
		for (const key in screens) {
			if (screens.hasOwnProperty(key)) {
				const element = screens[key];
				if (element) {
					breakpoints.push(key)
				}
			}
		}
		return breakpoints
	}


static getQueryParams = (data) => {
	return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
}

static getQueryString = (params) => {
    let values = params.split(" ");
		if(values){
			let queryString = Object.keys(values).map(
				key => 'search_by_name[]=' + values[key]
			).join('&');
			return queryString;
		}
  }
		/**
		 * getCode get uid by uri
		 * @type {string}
		 */
		static getCode = (uri) => {
		 return uri?.split("/").pop();
		}

		static isString = (inputText) =>{
	    if(typeof inputText === 'string' || inputText instanceof String){
	        //it is string
	        return true;
	    }else{
	        //it is not string
	        return false;
	    }
		}



		static getTotalWeekendDays = (fromDate, toDate) => {
			let count = 0;
			let curDate = +fromDate;
			while (curDate <= +toDate) {
				const dayOfWeek = new Date(curDate).getDay();
				const isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
				if (isWeekend) {
					count++;
				}
				curDate = curDate + 24 * 60 * 60 * 1000
			}
			return count;
		}



		static calculateTotalDays = (firstDate, secondDate) =>{
	    var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
			var firstDate1 = this.stringToDate(firstDate);
	    var secondDate1 = this.stringToDate(secondDate);
	    var diffDays = 1 + Math.round(Math.abs((firstDate1.getTime() - secondDate1.getTime())/(oneDay)));
	    return diffDays;
	  }

		static calcBusinessDays = (dDate1, dDate2) => { // input given as Date objects

			var dDate11 = this.stringToDate(dDate1);
	    var dDate22 = this.stringToDate(dDate2);

			var iWeeks, iDateDiff, iAdjust = 0;
	    if (dDate22 < dDate11) return -1; // error code if dates transposed
	    var iWeekday1 = dDate11.getDay(); // day of week
	    var iWeekday2 = dDate22.getDay();
	    iWeekday1 = (iWeekday1 === 0) ? 7 : iWeekday1; // change Sunday from 0 to 7
	    iWeekday2 = (iWeekday2 === 0) ? 7 : iWeekday2;
	    if ((iWeekday1 > 5) && (iWeekday2 > 5)) iAdjust = 1; // adjustment if both days on weekend
	    iWeekday1 = (iWeekday1 > 5) ? 5 : iWeekday1; // only count weekdays
	    iWeekday2 = (iWeekday2 > 5) ? 5 : iWeekday2;

	    // calculate differnece in weeks (1000mS * 60sec * 60min * 24hrs * 7 days = 604800000)
	    iWeeks = Math.floor((dDate22.getTime() - dDate11.getTime()) / 604800000)

	    if (iWeekday1 <= iWeekday2) {
	      iDateDiff = (iWeeks * 5) + (iWeekday2 - iWeekday1)
	    } else {
	      iDateDiff = ((iWeeks + 1) * 5) - (iWeekday1 - iWeekday2)
	    }

	    iDateDiff -= iAdjust // take into account both days on weekend

	    return (iDateDiff + 1); // add 1 because dates are inclusive
		}

		static stringToDate = (str) => {
			//const str = '06/15/2022';
			const [day, month, year] = str.split('/');
			return new Date(+year, +month - 1, +day);
		}

		static workingDaysBetweenDates = (d0, d1, holidays) => {
		  /* Two working days and an sunday (not working day) */
		  //var holidays = ['2016-05-03', '2016-05-05', '2016-05-07'];
		  var startDate = this.stringToDate(d0);
		  var endDate = this.stringToDate(d1);

		// Validate input
		  if (endDate < startDate) {
		    return 0;
		  }

		// Calculate days between dates
		  var millisecondsPerDay = 86400 * 1000; // Day in milliseconds
		  startDate.setHours(0, 0, 0, 1);  // Start just after midnight
		  endDate.setHours(23, 59, 59, 999);  // End just before midnight
		  var diff = endDate - startDate;  // Milliseconds between datetime objects
		  var days = Math.ceil(diff / millisecondsPerDay);

		  // Subtract two weekend days for every week in between
		  var weeks = Math.floor(days / 7);
		  days -= weeks * 2;

		  // Handle special cases
		  var startDay = startDate.getDay();
		  var endDay = endDate.getDay();

		  // Remove weekend not previously removed.
		  if (startDay - endDay > 1) {
		    days -= 2;
		  }
		  // Remove start day if span starts on Sunday but ends before Saturday
		  if (startDay === 0 && endDay !== 6) {
		    days--;
		  }
		  // Remove end day if span ends on Saturday but starts after Sunday
		  if (endDay === 6 && startDay !== 0) {
		    days--;
		  }


				/* Here is the code */
				holidays && holidays.forEach(item => {

					if ((new Date(item.holidayDate) >= this.stringToDate(d0)) && (new Date(item.holidayDate) <= this.stringToDate(d1))) {
						/* If it is not saturday (6) or sunday (0), substract it */
						if ((new Date(item.holidayDate).getDay() % 6) !== 0) {
							days--;
						}
					}
				});


		  return days;
		}


        static getSundayOfCurrentWeek = () => {
          const today = new Date();
          const first = today.getDate() - today.getDay() + 1;
          const last = first + 6;
          const sunday = new Date(today.setDate(last));
          return sunday;
      }

  static startWithVowel = (value, lang) => {
    if (!value || value.length <= 0) return false;
    if(!lang || lang !=='ca') return false;

    let lowercaseValue = value.toLowerCase();
    let firstChar = lowercaseValue.charAt(0);

    // Vamos a buscar si el carácter está en este arreglo
    const vowels = ["a", "e", "i", "o", "u"];

    // indexOf devuelve -1 si no encuentra el carácter en el arreglo
    // y si lo encuentra, devuelve el índice o posición, pero eso no nos importa ahora
    if (vowels.indexOf(firstChar) === -1) {
        return false;
    } else {
        return true;
    }
	}

	static groupBy = (array, key) =>{
		array.reduce((previous, currentItem) => {
			const group = currentItem[key];
			if (!previous[group]) previous[group] = [];
			previous[group].push(currentItem);
			return previous;
		}, {});
	}

	static getDescription = (node) => {
		const {field_series_session_number, field_subtitle, relationships} = node
		const {field_serie} = relationships
		const {field_total_sessions} = field_serie || ''
		if(field_series_session_number && field_total_sessions ){
			return `Sessió ${field_series_session_number} de ${field_total_sessions}`
		}
		if(field_subtitle){
			return field_subtitle
		}
		return ''
	}

	static getDate = (node, format, langcode="ca") => {
		moment.locale(langcode);
		const {field_start_time} = node
		switch (format) {

			case 'hour':
					 return moment(field_start_time).format("HH:mm")
		//	break;

			case 'day':
					 return moment(field_start_time).format("D")
			//	break;

			case 'month':
					return moment(field_start_time).format("MMMM")
			//	break;

			case 'shortMonth':
						return moment(field_start_time).format("MMM")
			//break;

			case 'weekday':
					 return moment(field_start_time).format("dddd")
		//		break;

			case 'full':
						 return moment(field_start_time).format("MMMM, D M, les H:mm")
		//	break;

			case 'dayMonthYear':
						 return moment(field_start_time).format("DDDD-MMMM-YYYY")
		//	break;

			default:
				 return moment(field_start_time).format("D")

		}
 }

 static getLocation = (node) => {
	 const {field_location} = node
	 var str = field_location.replace("nostres instal·lacions", "<a href='/contacte'>nostres instal·lacions<a>")
	 if(str){
		 	 //str = field_location.replace("servei online", "<a href='/mira'>servei online<a>")
			 return str;
	 }

	 return field_location
 }

 static getShortTitle = (title)  => {
	// return title
	 return title?.replace("Culte d'adoració", "Culte")
 }

 static getPath = (alias, lang='ca') => {
		 return lang === 'ca'
		 ? alias
		 : `/${lang}${alias}`
 }



	/**
	* Add a URL parameter
	* @param {string} url
	* @param {string} param the key to set
	* @param {string} value
	*/
	static addParam = (url, param, value) => {
	   param = encodeURIComponent(param);
	   var a = document.createElement('a');
	   param += (value ? "=" + encodeURIComponent(value) : "");
	   a.href = url;
	   a.search += (a.search ? "&" : "") + param;
	   return a.href;
	}

	/**
	* Add a URL parameter (or modify if already exists)
	* @param {string} url
	* @param {string} param the key to set
	* @param {string} value
	*/
	static addOrReplaceParam = (url, param, value) => {
	   param = encodeURIComponent(param);
	   var r = "([&?]|&amp;)" + param + "\\b(?:=(?:[^&#]*))*";
	   var a = document.createElement('a');
	   var regex = new RegExp(r);
	   var str = param + (value ? "=" + encodeURIComponent(value) : "");
	   a.href = url;
	   var q = a.search.replace(regex, "$1"+str);
	   if (q === a.search) {
	      a.search += (a.search ? "&" : "") + str;
	   } else {
	      a.search = q;
	   }
	   return a.href;
	}

	static mergeArraysWithoutDuplicates = (arr1, arr2) => {
	  const set = new Set([...arr1, ...arr2]);
	  return [...set].join(', ');
  }

	static trimToN = (text, maxLength, dotCount) => {
  let modText = text.trim();

  if (modText.length > maxLength) {
    modText = text.substring(0, maxLength - dotCount);
    modText = modText.padEnd(maxLength, ".");

    return modText;
  }

  return text;
}

static shuffleObjectsArray(array) {
  // Make sure the input array has at least two elements
  if (array.length <= 2) {
    return array;
  }

  const [first, second, ...rest] = array;

  if (typeof first !== 'object' || typeof second !== 'object') {
    console.error("shuffleObjectsArray: Invalid input. Expected objects as array elements.");
    return array;
  }

  const shuffledRest = this.shuffleObjectsArray(rest);

  if (!Array.isArray(shuffledRest) || shuffledRest.length === 0) {
    return [first, second];
  }

  const shuffled = [first, second, ...shuffledRest].slice(0, 4);
  return shuffled;
}

static shuffleArray(array){
	if (!Array.isArray(array)) {
		console.error("shuffleArray: Invalid input. Expected an array.");
		return;
	}

	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		const temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
}

static isExternal(url) {
	const pattern = /^(https?:)\/\//i;
	return pattern.test(url);
}

static removeCaUrl(url){
	if(!url){
		return;
	}
	return url.replace(/\/ca(?!\/(es|en))/, '');
}

static countCharactersWithoutHTML(value) {
  // Remove HTML tags from the string using a regular expression
  const strippedString = value.replace(/(<([^>]+)>)/gi, '');

  // Count the number of characters in the stripped string
  const characterCount = strippedString.length;

  return characterCount;
}

static removeMainLanguage(path){
	if(!path){
		return;
	}
	const caIndex = path?.indexOf("/ca"); // Find the position of the first occurrence of "/ca" in the path string
	if (caIndex !== -1) { // If "/ca" is found in the path string
		return path.substring(0, caIndex) + path.substring(caIndex + 3); // Remove "/ca" from the path string
	}
	return path
}

static getType = (item) => {
	  let output = ''
	  switch (item?.type) {
	    case 'node__blog_post':
	      output = 'Blog Post'
	      break;
	    case 'node__podcast':
	      output = 'Podcast'
	      break;
	    case 'node__page':
	      output = 'Page'
	      break;
	    case 'node__team':
	      output = 'Equip'
	      break;
	    case 'comment__comment':
	      output = 'Comentari'
	      break;
	    case 'node__event':
	      output = 'Event'
	      break;
	    case 'node__ministry':
	      output = 'Ministeri'
	      break;
	    default:
	      return'Page'
	  }
	  return output
	}

	static getDescription = (item) => {
	  let output = ''
	  switch (item.type) {
	    case 'comment__comment':
	      let desc = item?.comment_body?.processed ? Utils.trimToN(item?.comment_body?.processed, 75, 3) : ''
	      output = desc
	      break;
	    case 'node__blog_post':
	      let desc1 = item?.summary ? Utils.trimToN(item?.summary, 75, 3) : ''
	      output = desc1
	      break;
	    case 'node__team':
	      output = item?.title
	      break;
	    case 'node__page':
	      let desc2 = item?.summary ? Utils.trimToN(item?.summary, 75, 3) : ''
	      output = desc2
	      break;
	    default:
	      let desc3 = item?.summary ? Utils.trimToN(item?.summary, 75, 3) : ''
	      output = desc3
	  }
	  return output
	}

	static getUrl = (item) => {
	  let output = ''
	  switch (item.type) {
	    case 'comment__comment':
	      let url = item?.alias
	      output = url
	      break;
	    case 'node__blog_post':
	      let url1 = item?.alias
	      output = url1
	    break;
	    case 'node__team':
	      let url2 = item?.alias
	      output = url2
	      break;
	    case 'node__page':
	      let url3 = item?.alias
	      output = url3
	      break;
	    case 'node__podcast':
	      let url5 = 'https://www.poderato.com/launida'
	      output = url5
	    break;
			case 'node__event':
	      let url6 = item?.alias
	      output = url6
	    break;
	    case 'node__ministry':
	      output = item?.alias
	      break;
	    default:
	      let url4 = '/'
	      output = url4
	  }
	  return output
	}





}

export default Utils;
